<template>
    <div class="parking">
        <parking-amap></parking-amap>
    </div>
</template>

<script>
import ParkingAmap from "@/components/parking/parking-amap.vue";

export default {
    name: "Parking",
    components: {
        ParkingAmap,
    },
    data() {
        return {};
    },
    beforeRouteEnter(to, from, next) {
        console.log(to);
        next();
    },
    mounted() {},
    methods: {},
    // activated() {
    //     console.log("我被缓存了");
    // },
    // deactivated() {
    //     console.log("我退出了");
    // },
};
</script>

<style lang="less" scoped>
.parking {
}
</style>
